import moment from 'moment';
import { shortDateFormat } from 'shared/models/Dates';

export const formatShortDate = (stringDate: string) => moment(stringDate).format(shortDateFormat);

export const formatYearFromEuDate = (stringDate: string) => String(moment(stringDate).year());
